import axios from 'axios';
import { message } from 'antd';
import authService from './authService';

// Tạo instance axios với config mặc định
const axiosInstance = axios.create({
  headers: {
    'Content-Type': 'application/json'
  }
});

// Request interceptor
axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        } else {
            // Nếu không có token, chuyển hướng về trang login
            window.location.href = '/login';
            return Promise.reject('Vui lòng đăng nhập để tiếp tục');
        }
        // Log request URL để debug
        console.log('Request URL:', config.url);
        console.log('Request Headers:', config.headers);
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor
axiosInstance.interceptors.response.use(
    (response) => {
        return response;
    },
    async (error) => {
        // Log chi tiết lỗi
        console.error('API Error:', {
            url: error.config?.url,
            method: error.config?.method,
            status: error.response?.status,
            data: error.response?.data
        });

        const originalRequest = error.config;

        // Xử lý token hết hạn (401)
        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            // Nếu refresh token thất bại, đăng xuất
            authService.logout();
            window.location.href = '/login';
            message.error('Phiên làm việc đã hết hạn, vui lòng đăng nhập lại');
        }

        // Xử lý lỗi không có quyền truy cập (403)
        if (error.response?.status === 403) {
            message.error('Bạn không có quyền thực hiện thao tác này');
        }

        // Xử lý lỗi không tìm thấy (404)
        if (error.response?.status === 404) {
            message.error('Không tìm thấy tài nguyên yêu cầu');
        }

        // Xử lý lỗi server (500)
        if (error.response?.status === 500) {
            message.error('Lỗi hệ thống, vui lòng thử lại sau');
        }

        return Promise.reject(error);
    }
);

export default axiosInstance; 